// SessionInvalidatedModal — displayed when backend returns SESSION_INVALIDATED
// Global singleton controlled via static show() method. Independent of React tree.
import React, { useEffect, useState } from 'react';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { ThemeModal, ThemeButton } from '../../pages/Styles/Theme';
import { STORAGE_KEYS } from '../../utils/constants';

let showFn = null;
let isShown = false;

export const showSessionInvalidatedModal = () => {
  if (isShown) return;
  isShown = true;
  if (showFn) showFn();
};

const AUTO_REDIRECT_MS = 3000;

const SessionInvalidatedModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    showFn = () => setOpen(true);
    return () => {
      showFn = null;
    };
  }, []);

  const handleOk = () => {
    setOpen(false);
    isShown = false;
    // Clear auth-related keys then redirect
    localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
    localStorage.removeItem(STORAGE_KEYS.USER_DATA);
    localStorage.removeItem(STORAGE_KEYS.PERMISSIONS);
    localStorage.removeItem('expiresAt');
    window.location.replace('/login');
  };

  useEffect(() => {
    if (!open) return undefined;
    const timer = setTimeout(handleOk, AUTO_REDIRECT_MS);
    return () => clearTimeout(timer);
  }, [open]);

  return (
    <ThemeModal
      open={open}
      onCancel={handleOk}
      closable={false}
      maskClosable={false}
      centered
      width={440}
      title={null}
      footer={null}
    >
      <div style={{ padding: '8px 4px 4px 4px', textAlign: 'center' }}>
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            background: 'rgba(46, 69, 218, 0.08)',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 16,
          }}
        >
          <ExclamationCircleFilled style={{ fontSize: 30, color: '#2E45DA' }} />
        </div>

        <h3
          style={{
            margin: '0 0 10px 0',
            color: '#2C2926',
            fontSize: 18,
            fontWeight: 600,
          }}
        >
          You've been signed out
        </h3>

        <p
          style={{
            margin: '0 0 24px 0',
            color: '#6D6A67',
            fontSize: 13,
            lineHeight: 1.6,
            padding: '0 12px',
          }}
        >
          You signed in on another device or browser. For your security, you've been signed out of this session.
        </p>

        <ThemeButton
          size="large"
          className="solidPurple"
          onClick={handleOk}
          style={{ minWidth: 180 }}
        >
          Go to Login
        </ThemeButton>
      </div>
    </ThemeModal>
  );
};

export default SessionInvalidatedModal;
